<template><div><p class="d-docsite--paragraph">Design Tokens are all the defined values that are part of the design system, such as color, spacing, typography, and more. Design tokens are published in many different forms so they can be consumed on all platforms (CSS, LESS, Android, iOS, etc).</p>
<p class="d-docsite--paragraph">See the <a href="https://github.com/dialpad/dialtone/tree/staging/packages/dialtone-tokens#readme" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Dialtone Tokens README</a> for usage info.</p>
<all-tokens /></div></template>


<script setup>
  import AllTokens from '@baseComponents/tokens/AllTokens.vue';
</script>